module.exports = __webpack_public_path__ + "img/research_6.91688b42.png";